import { getQueryParam, navigate } from '../services/window-location-service';

export class PageServicesLanding extends DrupalBehavior {
  onReady(document) {
    function browseByAlphabet(e) {
      if (e.matches) {
        $('.services-landing--letters--content > div').css({ height: 0 });
        var letters = document.querySelector(
          '.services-landing--letters--content > div'
        );
        $('.services-landing--letters button').on('click', function () {
          var $parent = $(this).parent().toggleClass('open');
          if ($parent.hasClass('open')) {
            gsap.to(letters, {
              duration: 0.5,
              ease: 'power4.out',
              height: 'auto',
            });
          } else {
            gsap.to(letters, { duration: 0.5, ease: 'power4.out', height: 0 });
          }
        });
      } else {
        $('.services-landing--letters').removeClass('open');
        $('.services-landing--letters button').off();
        $('.services-landing--letters--content > div').css({ height: 'auto' });
      }
    }

    let mql = window.matchMedia('(max-width: 991px)');
    mql.addEventListener('change', browseByAlphabet);
    browseByAlphabet(mql);
    $('body').addClass('services-landing');
  }

  onContent(context) {
    if (typeof this.settings.servicesSearchForm != 'undefined') {
      let settings = this.settings.servicesSearchForm;

      let $audience_radios = this.setUpAudience(context, settings);
      this.setUpSearch(context, settings, $audience_radios);
      this.scrollToResultsOnFilterOrSearch(context);
    }
  }

  scrollToResultsOnFilterOrSearch(context) {
    this.scrollToResultsOnFilter(context);
    this.scrollToResultsOnSearch(context);
  }

  scrollToResultsOnSearch(context) {
    const query = getQueryParam('text');
    if (query) {
      this.scrollToResults(context);
    }
  }

  scrollToResultsOnFilter(context) {
    const category = getQueryParam('category');
    if (category) {
      this.scrollToResults(context);
    }
  }

  scrollToResults(context) {
    const mainMenuHeight = $('#block-rush-theme-mainmenu').outerHeight(true);
    const $results = $(
      '.services-landing--listing, .services-landing--results',
      context
    );
    const targetPosition = $results.offset().top;

    $('html, body').animate({
      scrollTop: targetPosition - mainMenuHeight
    }, 250);
  }

  setUpSearch(context, settings, $audience_radios) {
    let $search = jQuery('input[name=text]', context);
    if ($search.length > 0) {
      this.setUpAutoComplete($search, settings, $audience_radios);
      this.setUpClearButton($search);
      this.setUpResetButton();
    }
  }

  setUpResetButton() {
    const currentUrl = new URL(window.location.href);
    const currentParams = currentUrl.searchParams;
    const textValue = currentParams.get('text');
    const categoryValue = currentParams.get('category');

    if (textValue || categoryValue) {
      const $resetButtonWrapper = jQuery(
        '<div class="reset-button-wrapper"></div>'
      );
      const $resetButton = jQuery(
        '<button class="reset-button" type="button">Reset search</button>'
      );
      const audienceValue = currentParams.get('audience');
      const newParams = new URLSearchParams();

      if (audienceValue) {
        newParams.set('audience', audienceValue);
      }

      const newUrl = window.location.pathname + '?' + newParams.toString();

      $resetButton.on('click', function () {
        navigate(newUrl);
      });

      $resetButtonWrapper.append($resetButton);

      const $formWrapper = jQuery('.form-letters--wrapper');
      $formWrapper.after($resetButtonWrapper);
    }
  }

  setUpClearButton($search) {
    const $clear = jQuery(
      '<button class="clear-button" type="button"></button>'
    );
    $search.after($clear);
    $clear.on('click', function () {
      $search.val('');
      $clear.hide();
    });

    if ($search.val().length > 0) {
      $clear.show();
    }

    $search.on('input', function (event) {
      const currentText = event.target.value;
      if (currentText.length > 0) {
        $clear.show();
      } else {
        $clear.hide();
      }
    });
  }

  setUpAutoComplete($search, settings, $audience_radios) {
    new autoComplete({
      selector: $search.get(0),
      source: function (term, response) {
        jQuery.getJSON(
          settings.suggest,
          {
            q: term,
            audience: $audience_radios.filter(':checked').val(),
          },
          function (data) {
            response(data);
          }
        );
      },
      onSelect: function (e, term, item) {
        // When a suggestion is selected, submit the form.
        $search.val(term);
        $search.closest('form').submit();
      },
    });
  }

  setUpAudience(context, settings) {
    let $audience_radios = jQuery('input.audience-selector', context);
    if ($audience_radios.length > 0) {
      // Submit the form when the age radio changes.
      $audience_radios.change(function (e) {
        $audience_radios.closest('form').submit();
      });

      // Update the page title.
      let val = $audience_radios.filter(':checked').val();
      if (typeof settings[val] != 'undefined') {
        let $h1 = jQuery('h1');
        let title = settings[val];
        $h1.text(title);
      }
    }
    return $audience_radios;
  }
}

DrupalBehavior.register(
  'rush_theme.pages',
  'services_landing',
  PageServicesLanding
);
